import React, {Component} from 'react';

class About extends Component {
    render() {
        if (this.props.data) {
            var name = this.props.data.name;
            var bio = this.props.data.bio;
            var city = this.props.data.address.city;
            var state = this.props.data.address.state;
            var zip = this.props.data.address.zip;
            var phone = this.props.data.phone;
            var resumeDownload = this.props.data.resumeDownload;
            var email = this.props.data.email;
        }
        return (
            <section id="about">
                <div className="row">
                    <div className="three columns">
                        <img className="profile-pic"
                            src={
                                require(`./portfolio/Rahul.jpg` ).default
                            }
                            alt="Rahul Beniwal"/>
                    </div>
                    <div className="nine column main-col">
                        <h2>
                            About Me</h2>
                        <p>{bio}</p>
                        <div className="row">
                            <div className="columns contact-detail">
                                <h2>Contact Detail</h2>
                                <p className="address">
                                    <span>{name}</span>
                                    <br/>
                                    <span>{city + "  "}
                                        {state}
                                        {zip}</span>
                                    <br/>
                                    <span>{phone}</span><br/>
                                    <span>{email}</span>
                                </p>
                            </div>
                            <div className="columns download">
                                <p>
                                    <a href={resumeDownload} className="button"> <i className="fa fa-download"></i> Download Resume </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default About;
